import React from "react"
import { Link } from "gatsby"

const WeAreFooter = () => {
  //const [showModal, setShowModal] = useState(false)
  // const openModal = () => {
  //   setShowModal(prev => !prev)
  // }
  return (
    <section className="flex flex-col md:flex-row container mx-auto px-6 pt-20 pb-6">
      <div className="md:w-3/4">
        <h2 className="text-6xl font-bold w-full block text-secondary mb-4 md:text-6xl">
          We are
        </h2>
        <p className="mb-4 lg:mr-8 leading-relaxed text-4xl font-medium pb-8">
          a young company with new ideas, focused on continuous growth.
        </p>
        <Link
          to="/contact"
          className="mx-auto md:mx-px text-white shadow-lg bg-secondary hover:bg-neutral hover:text-primary btn"
        >
          Get in touch
        </Link>
      </div>
      <div className="md:block md:w-1/4 pt-10 md:pl-8 lg:pl-0">
        <ul className="font-semibold w-1/2 mx-auto text-center md:w-full md:text-left">
          <li className="py-3 border-red-500 border-b-2">
            <Link to="/about-us">About Us</Link>
          </li>
          <li className="py-3 border-red-500 border-b-2">
            <Link to="/services">Services</Link>
          </li>
          <li className="py-3 border-red-500 border-b-2">
            <Link to="/careers">Careers</Link>
          </li>
          <li className="py-3 border-red-500 border-b-2">
            <Link to="/our-partners">Our partners</Link>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default WeAreFooter
